<template>
  <div>
     <div class="row inputBox noselect">
      
          <div v-if="icon" class="icon">
            <img :src="`/images/input/${icon}.svg`">
          </div>
          
          <input
              type="text"
              class="input"   
              style="box-shadow: none; background-color: none; width: 100%; border-radius: 10px; margin: 0; padding: 0;"
              :class="{inputIcon: icon}"              
              :placeholder="placeholder"
              :value="modelValue" 
              @input="$emit('update:modelValue', $event.target.value)"
              >
          
          <div class="row ch pointer click" style="padding-right: 12px;" v-if="modelValue" @click="$emit('update:modelValue','')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="black" fill-opacity="0.1"/><path d="M9 9L15 15M15 9L9 15" stroke="black" stroke-opacity="0.3" stroke-width="1.2" stroke-linecap="round"/></svg>
          </div>          
        </div>
      </div>
        <!-- 

          <TextInput v-model="query" placeholder="Search" class="w300" height="300px"/>
         -->
</template>

<script>
export default {   
    data: function () {return {}},
    props: {      
      title: String,
      must: Boolean,
      sub: String,
      modelValue:String,
      placeholder: String,           
      height: {type:String, default:'300px'},      
      icon: String,
      error: String,
    },
}
</script>

<style scoped>


.inputBox {  
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: var(--inputBack);
  box-shadow: var(--inputShadow);
  border-radius: var(--inputBorderRadius);
  padding: 0;
  height: 52px;
  width: 100%;
  z-index: 1;
}

.inputIcon {
  padding-left: 44px;
}

.icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center; 
  margin: 0 12px 0 16px; 
}

.iconpadding {
  padding-left: 30px;
}

div.focus {
  border: 1px solid blue;
}

</style>

